export default "__VITE_ASSET__BpDL0c9a__"